module.exports = __webpack_public_path__ + "img/DE03485.914e51dc.png";